import { defineStore } from 'pinia';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, AzureDevOpsScopes } from '@/settings';

const useAuthStore = defineStore('auth', {
  state: () => ({
    msalInstance: null,
    isAuthenticated: false,
    user: null,
    accessToken: null,
  }),

  actions: {
    getRequest(askScopes) {
      let scopes;
      if (askScopes === undefined) {
        scopes = AzureDevOpsScopes;
      } else {
        scopes = askScopes;
      }
      const request = {
        scopes,
      };

      return request;
    },
    async initializeMsal() {
      if (this.msalInstance) return this.msalInstance;

      try {
        this.msalInstance = new PublicClientApplication(msalConfig);
        await this.msalInstance.initialize();
      } catch (error) {
        console.error('Failed to initialize MSAL:', error);
        throw error;
      }
      return this.msalInstance;
    },

    async checkAuthStatus() {
      if (!this.msalInstance) {
        await this.initializeMsal();
      }

      const activeAccount = this.msalInstance.getActiveAccount();
      this.isAuthenticated = !!activeAccount;
      this.user = activeAccount;
      return this.isAuthenticated;
    },
    async getAccessToken(scope) {
      if (!this.msalInstance) {
        await this.initializeMsal();
      }
      const request = this.getRequest(scope);
      this.accessToken = await this.msalInstance.acquireTokenSilent(request);
      return this.accessToken.accessToken;
    },
    async login() {
      if (!this.msalInstance) {
        await this.initializeMsal();
      }

      try {
        this.accessToken = await this.msalInstance.loginPopup({});

        const accounts = this.msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalInstance.setActiveAccount(accounts[0]);
          await this.checkAuthStatus();
        }

        return this.isAuthenticated;
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      }
    },

    async logout() {
      if (this.msalInstance) {
        await this.msalInstance.logoutPopup({});
        this.isAuthenticated = false;
        this.user = null;
      }
    },
  },
});
export default useAuthStore;
